export default __webpack_public_path__ + "static/media/bas-logo.679d60b5.png";